// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@keyframes show-card-data {\n0% {\r\n    opacity: 0;\r\n    bottom: -10px;\n}\n25% {\r\n    opacity: 0;\n}\n100% {\r\n    opacity: 1;\r\n    bottom: 0px;\n}\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
